import script from "./InputFieldWithSideBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputFieldWithSideBtn.vue?vue&type=script&setup=true&lang=ts"

import "./InputFieldWithSideBtn.vue?vue&type=style&index=0&id=be06ccc6&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be06ccc6"]])

export default __exports__